<template>
	<div class="drSearchSelect">
		<el-select class="multi" v-model="search_type" placeholder="请选择">
			<el-option v-for="(item, index) in searchTypeArr" :label="item.label" :value="item.value" :key="index"></el-option>
		</el-select>
		<dr-select
			class="dr-select"
			@input="input"
			@change="change"
			:search_type="search_type"
			:platformId="PLATFORM_KS.value"
			is-team
			:multiple-limit="10"
			multiple
			collapse-tags
			placehoder="请输入/选择"
		/>
	</div>
</template>
<script>
import drSelect from '@/components/drSelect';
import { PLATFORM_KS } from '@/utils/dataMap';
export default {
	name: 'drSearchSelect',
	components: {
		drSelect,
	},
	props: {
		searchTypeArr: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			search_type: '1',
			PLATFORM_KS,
		};
	},
	methods: {
		input(e) {
			this.$emit('input', e);
		},
		change(e, obj) {
			this.$emit('change', e, obj);
		},
	},
};
</script>
<style lang="less" scoped>
.drSearchSelect {
	.multi {
		/deep/ .el-input {
			width: 120px;
		}
		/deep/ .el-input__inner {
			border-right: none;
			border-color: #e3e3e3;
			border-top-left-radius: 2px;
			border-bottom-left-radius: 2px;
		}
	}
	.dr-select {
		/deep/ .el-input__inner {
			border-top-right-radius: 2px;
			border-bottom-right-radius: 2px;
		}
	}
	/deep/ .el-input__inner {
		border-radius: 0px;
	}
	/deep/ .input-with-select .el-input-group__prepend {
		background-color: #fff;
	}
}
</style>
